import { useState, useCallback } from 'react';

export default function useLayer() {
	const fnTransitionDuration = (time) => ({
		WebkitTransitionDuration: `${time}ms`,
		transitionDuration: `${time}ms`,
	});

	// markup
	const [view, setView] = useState(false);
	const [layerType, setLayerType] = useState('');
	const [layerPayload, setLayerPayload] = useState(null);
	// active: transition-duration
	const [transitionDuration, setTransitionDuration] = useState(fnTransitionDuration(0));
	// active: className
	const [delayTime, setDelayTime] = useState(0);

	const handleLayerOpen = useCallback((option) => {
		setView(true);
		if (option?.type) setLayerType(option.type);
		if (option?.payload) setLayerPayload(option.payload);
		const time = option ? option.time || 0 : 0;
		setTransitionDuration(fnTransitionDuration(time));
		setTimeout(() => setDelayTime(time), 0);
	}, []);

	const handleLayerClose = useCallback((option) => {
		setDelayTime(0);
		const time = option ? option.time || 0 : 0;
		setTransitionDuration(fnTransitionDuration(time));
		setTimeout(() => {
			setView(false);
			setLayerType('');
			setLayerPayload(null);
		}, time);
	}, []);

	return {
		view,
		layerType,
		layerPayload,
		handleLayerOpen,
		handleLayerClose,
		delayTime,
		transitionDuration,
	};
}
